import { animate, state, style, transition, trigger } from '@angular/animations';
import { GridFilterIconComponent } from '../../../shared/components/layout/filter-icon/filter-icon.component';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';

import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDatepicker, MatDatepickerModule, MatDatepickerInput } from '@angular/material/datepicker';
import { ReportsService } from '../../../api/services/reports/reports.service';
import { SnackbarComponent, ToastType } from '../../../shared/components/layout/snackbar/snackbar.component';
import { LookupsService } from '../../../api/services/lookups/lookups.service';
import { LookupsStore } from '../../../api/services/lookups/lookups.store';
import { SpinnerService } from '../../../shared/services/spinner.service';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'app-training-report',
  templateUrl: './training-report.component.html',
  styleUrls: ['./training-report.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*', display: 'block' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  imports: [
    MatToolbarModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatDatepickerModule,
    MatDatepickerInput,
    MatNativeDateModule,
    MatOptionModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatCardModule,
    MatAutocompleteModule,
    MatTableModule,
    GridFilterIconComponent,
  ],
})
export class TrainingReportComponent implements OnInit {
  readonly lookupsStore = inject(LookupsStore);
  displayedColumns: string[] = [
    'learningPathName',
    'trainingType',
    'state',
    'notStartedCount',
    'inProgressCount',
    'completeCount',
    'registrationCount',
    'certsIssuedCount',
  ];
  tableHeading: string[] = [
    'Course',
    'Training',
    'State',
    'Not Started',
    'In Progress',
    'Complete',
    'Total Registrations',
    'Certificates Issued',
  ];
  expandedElement: any | null;
  dataSource!: MatTableDataSource<any>;
  disableflag: boolean = false;
  clearBtnFlag: boolean = true;
  expandElements: any[] = [];
  displayData: any = [];
  noSearchData: boolean = false;
  searchData: any;
  @ViewChild(MatSort) sort!: MatSort;
  filtersForm!: FormGroup;
  openFilters: boolean = true;
  totalNotStartedCourse: number = 0;
  totalIncompleteCourse: number = 0;
  totalCompleteCourse: number = 0;
  totalRegistrations: number = 0;
  totalCertificatesIssued: number = 0;

  constructor(
    private fb: FormBuilder,
    private lookupsService: LookupsService,
    private snackBar: MatSnackBar,
    private spinnerService: SpinnerService,
    private reportsService: ReportsService,
  ) {}

  ngOnInit(): void {
    this.spinnerService.whiteBackground();
    this.lookupsService.getStates();
    this.lookupsService.getTrainings();

    const today = new Date();
    const fromDate = new Date(today.getFullYear() - 1, today.getMonth(), 1);
    const toDate = new Date(today.getFullYear(), today.getMonth(), 0);

    this.filtersForm = this.fb.group({
      search: this.fb.control(''),
      fromDate: this.fb.control(fromDate || null),
      toDate: this.fb.control(toDate || null),
      orgName: this.fb.control(''),
      trainingType: this.fb.control(null),
      stateId: this.fb.control(null),
    });

    // this.organizationLookup('a');

    // this.filtersForm
    //   .get('orgName')
    //   ?.valueChanges.pipe(
    //     tap((val: any) => {
    //       if (!val?.value && val?.length > 3) {
    //         this.organizationLookup(val);
    //       } else if (!val?.length) {
    //         this.organizationLookup('a');
    //       }
    //     })
    //   )
    //   .subscribe();

    this.initGridData();
  }

  initGridData() {
    this.applyFilters();
    this.filtersForm.valueChanges.subscribe((changes) => {
      this.applyFilters();
    });
  }

  applyFilters() {
    this.spinnerService.show();
    const formData = this.filtersForm.value;
    const { fromDate, toDate, search, orgName, trainingType, stateId } = formData;
    const criteria = {
      fromDate: this.getDateString(fromDate) ?? '',
      toDate: this.getDateString(toDate) ?? '',
      search: search ?? '',
      entityGuid: orgName?.value ?? '',
      trainingType: trainingType ?? '',
      stateId: stateId ?? '',
    };

    this.reportsService
      .getTrainingReport(criteria)
      .pipe(
        catchError((error) => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            data: { toastType: ToastType.Error, message: 'Something went wrong, please try Again' },
          });
          return of({ rows: [] });
        }),
      )
      .subscribe((results: any) => {
        this.spinnerService.hide();
        if (criteria.search) {
          const searchResults = Object.values(results).filter((x: any) =>
            x.learningPathName.toLowerCase().includes(criteria.search.toLowerCase()),
          );
          this.displayData = searchResults;
        } else {
          Object.keys(results).forEach((key) => {
            if (key === 'totalNotStartedCourse') {
              this.totalNotStartedCourse = results[key];
            } else if (key === 'totalIncompleteCourse') {
              this.totalIncompleteCourse = results[key];
            } else if (key === 'totalCompleteCourse') {
              this.totalCompleteCourse = results[key];
            } else if (key === 'totalRegistrations') {
              this.totalRegistrations = results[key];
            } else if (key === 'totalCertificatesIssued') {
              this.totalCertificatesIssued = results[key];
            }
          });
          this.displayData = results.rows;
        }
      });
  }

  // organizationLookup(val: any) {
  //   this.api.lookups
  //     .getOrganization(val)
  //     .pipe(
  //       catchError((e) => throwError(() => e)),
  //       tap((data: any) => {
  //         if (data) {
  //           this.searchData = data;
  //         }
  //       })
  //     )
  //     .subscribe({
  //       next: () => {},
  //       error: (e) => {
  //         this.snackBar.openFromComponent(SnackbarComponent, { duration: 3000, data: { toastType: ToastType.Error, message: 'Something went wrong' }})
  //       },
  //     });
  // }

  checkExpanded(element: any): boolean {
    let flag = true;
    this.expandElements.forEach((e: any) => {
      if (e === element) {
        flag = false;
      }
    });
    return flag;
  }

  pushPopElement(element: any) {
    const index = this.expandElements.indexOf(element);
    if (index === -1) {
      this.expandElements.push(element);
    } else {
      this.expandElements.splice(index, 1);
    }
  }

  displayFn(search: any): string {
    return search && search.name ? search.name : search?.length > 0 ? search : '';
  }

  exportCsv() {
    const formData = this.filtersForm.value;
    const { fromDate, toDate, search, orgName, trainingType, stateId } = formData;
    const criteria = {
      fromDate: this.getDateString(fromDate) ?? '',
      toDate: this.getDateString(toDate) ?? '',
      search: search ?? '',
      entityGuid: orgName?.value ?? '',
      trainingType: trainingType ?? '',
      stateId: stateId ?? '',
    };
    this.disableflag = true;
    this.reportsService.exportTrainingReport(criteria).subscribe({
      next: () => {
        this.disableflag = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          data: { toastType: ToastType.Success, message: 'Report will be sent to your email' },
        });
      },
      error: () => {
        this.disableflag = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          data: { toastType: ToastType.Error, message: 'Something went wrong, please try Again' },
        });
      },
    });
  }

  clearFilters() {
    this.filtersForm.reset();
    const today = new Date();
    const fromDate = new Date(today.getFullYear() - 1, today.getMonth(), 1);
    const toDate = new Date(today.getFullYear(), today.getMonth(), 0);
    this.filtersForm.controls?.['toDate']?.setValue(toDate);
    this.filtersForm.controls?.['fromDate']?.setValue(fromDate);
  }

  closeFilter() {
    this.openFilters = !this.openFilters;
  }

  chooseFromMonthHandler(normalizedMonth: any, datepicker: MatDatepicker<any>) {
    datepicker.close();
    const month = normalizedMonth.getMonth();
    const year = normalizedMonth.getFullYear();
    this.filtersForm.get('fromDate')?.setValue(new Date(year, month, 1));
  }

  chooseToMonthHandler(normalizedMonth: any, datepicker: MatDatepicker<any>) {
    datepicker.close();
    const month = normalizedMonth.getMonth();
    const year = normalizedMonth.getFullYear();
    this.filtersForm.get('toDate')?.setValue(new Date(year, month + 1, 0));
  }

  getDateString(date: any) {
    if (date) {
      const newDate = new Date(date);
      return newDate.toUTCString();
    }
    return '';
  }
}
